/**
 * Post-checkout age verification: cart notice modal + helpers.
 */
(function () {
  var STORAGE_KEY = 'bp_age_notice_dismissed';

  function tagsRequireAgeVerification(tags) {
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      var lo = String(tags[i]).toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
      if (lo === 'age verification' || lo === 'age-verification') return true;
    }
    return false;
  }

  function isNoticeDismissed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setNoticeDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  function showModal() {
    if (isNoticeDismissed()) return;
    var overlay = document.getElementById('bp-age-notice-overlay');
    if (!overlay) return;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bp-age-notice-open');
  }

  function hideModal() {
    var overlay = document.getElementById('bp-age-notice-overlay');
    if (!overlay) return;
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bp-age-notice-open');
  }

  window.bpTagsRequireAgeVerification = tagsRequireAgeVerification;

  window.bpShowAgeVerificationNotice = function () {
    showModal();
  };

  window.assertAgeVerifiedForProductTags = function () {
    return true;
  };

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('bp-age-notice-overlay');
    if (!overlay) return;

    var closeBtn = document.getElementById('bp-age-notice-close');
    var dismissCheck = document.getElementById('bp-age-notice-dismiss');
    var backdrop = overlay.querySelector('.bp-age-notice-backdrop');

    function close() {
      if (dismissCheck && dismissCheck.checked) setNoticeDismissed();
      hideModal();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    overlay.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });
})();
